/*@flow*/
import * as t from 'lib/t';
import naturalSorter from 'lib/naturalSorter';
import enumList from './util/enumList';
import enumsFor from './util/enumsFor';
import { Id, NormalizedNumber } from 'types/tcomb';
import mkTagTemplate from 'lib/templates/mkTagTemplate';

const config = {
  id: t.maybe(Id).opt({ type: 'hidden' }),
  name: t.String,
  address: t.maybe(t.String).opt({
    template: 'LocationPickerTemplate',
  }),
  mapLabel: t.maybe(t.String),
  theGeom: t.String.opt({ type: 'hidden' }),
  status: t.String.options({
    template: 'DevelopmentStatus',
    attrs: {
      placeholder: 'Choose status',
      classNamePrefix: 'Select',
    },
  }),
  visibility: enumsFor('visibility'),
  developmentType: enumsFor('developmentType').opt({
    nullOption: { value: '', text: 'Choose development type' },
  }),
  description: t.maybe(t.String).opt({
    type: 'textarea',
    template: 'TextEditorTemplate',
  }),
  photoUrls: t.maybe(t.list(t.String)).opt({
    label: 'Photo(s)',
    template: 'PhotoUploaderTemplate',
    help: 'Photos must be larger than 600px wide.',
  }),
  documentsAttributes: t
    .maybe(t.list(t.struct({ name: t.String, url: t.String })))
    .opt({
      label: 'Additional Information & Supporting Documents',
      template: 'DocumentUploaderTemplate',
      help: 'Accepted file types: pdf, png, jpg.',
    }),
  floorArea: t.maybe(NormalizedNumber),
  financing: t.maybe(t.String),
  expectedCompletionYear: t.maybe(t.Number).opt({
    label: 'Expected completion year',
    template: 'SelectTemplate',
    categories: Array(50)
      .fill(new Date().getFullYear() - 37)
      .map((s, i) => {
        const year = s + 1 + i;
        return [year, year];
      }),
    isMulti: false,
    attrs: {
      placeholder: 'Choose a year',
    },
  }),
  uses: t.maybe(t.list(t.String)).opt({
    label: 'Use',
    template: 'SelectTemplate',
    categories: enumList.use.sort(naturalSorter),
    isMulti: true,
    attrs: {
      placeholder: 'Choose a use',
      classNamePrefix: 'Select',
    },
  }),
  tags: t.maybe(t.list(t.String)).opt({
    template: mkTagTemplate('developments'),

    attrs: {
      placeholder: 'Select...',
    },
  }),
  notes: t
    .maybe(t.String)
    .opt({ type: 'textarea', template: 'TextEditorTemplate' }),
  url: t.maybe(t.String),
  cost: t.maybe(NormalizedNumber),
  program: t.maybe(t.String),
  multifamilyUnits: t.maybe(NormalizedNumber),
  affordableMultifamilyUnits: t.maybe(NormalizedNumber),
  multifamilySqft: t.maybe(NormalizedNumber).opt({
    label: 'Multifamily sq ft',
  }),
  officeSqft: t.maybe(NormalizedNumber).opt({
    label: 'Office sq ft',
  }),
  retailSqft: t.maybe(NormalizedNumber).opt({
    label: 'Retail sq ft',
  }),
  commercialSqft: t.maybe(NormalizedNumber),
  industrialSqft: t.maybe(NormalizedNumber).opt({
    label: 'Industrial sq ft',
  }),
  otherSqft: t.maybe(NormalizedNumber).opt({
    label: 'Other sq ft',
  }),
  hospitalityUnits: t.maybe(NormalizedNumber),
  hospitalitySqft: t.maybe(NormalizedNumber),
  commFacilitiesSqft: t.maybe(NormalizedNumber).opt({
    label: 'Community Facilities sq ft',
  }),
  parkingSpots: t.maybe(NormalizedNumber),
  architect: t.maybe(t.String),
  developer: t.maybe(t.String),
  ownershipType: t.maybe(enumsFor('ownershipType')).opt({
    nullOption: { value: '', text: 'Choose ownership type' },
  }),
  floors: t.maybe(t.Number).opt({
    label: 'Number of Floors',
  }),
  contactName: t.maybe(t.String).opt({
    label: 'Contact Name',
  }),
  email: t.maybe(t.String).opt({
    label: 'Contact Email',
  }),
};
export default t.struct(config, 'Development').opt<any>({ legend: '' });
